<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="商户简码">
					<c-input name="merchant_code" placeholder="请输入商户简码"></c-input>
				</m-search-item>
				<m-search-item label="商户名称">
					<c-input name="merchant_name" placeholder="请输入商户名称"></c-input>
				</m-search-item>
				<m-search-item label="是否启用">
					<c-select name="is_enabled" :options="enabledOptions" placeholder="请选择启用状态"></c-select>
				</m-search-item>
			</m-search>

			<m-operate>
				<c-button color="main" v-if="auth('b_profit_merchant_edit')" prepend-icon="tf-add" @click="openAdd()">添加调拨商户</c-button>
			</m-operate>

			<c-table ref="list" height="grow">
				<c-table-column
					label="商户简码"
					name="merchant_code"
					width="100"
				></c-table-column>

				<c-table-column
					label="商户名称"
					name="merchant_name"
					width="260"
				></c-table-column>

				<c-table-column
					label="分润比例"
					name="share_ratio"
					width="90"
				>
					<template #default="{data}">
						{{formatRatio(data.share_ratio)}}
					</template>
				</c-table-column>

				<c-table-column
					label="是否启用"
					name="is_enabled"
					width="100"
				>
					<template #default="{data}">
						<c-switch v-if="auth('b_profit_merchant_edit')" v-model="data.is_enabled" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="toggleHandle(arguments[0], arguments[1], data)"></c-switch>
						<c-state v-else dict="disableEnableDic" :value="data.is_enabled"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_name"
					width="100"
				></c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="130"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="150"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_profit_merchant_edit')" icon="tf-edit" @click="openEdit(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_profit_merchant_edit')" icon="tf-trash" color="red" @click="removeMerchant(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>

			<!--添加/编辑调拨商户弹窗-->
			<c-dialog ref="dialog" width="500" @resolve="submitMerchant">
				<c-form ref="form" vertical unit-width="100%">
					<c-form-item label="商户简码" required>
						<c-input v-model="merchantCode" name="merchant_code" :disabled="editState" placeholder="请输入商户简码" @input="onCodeInput" @blur="checkMerchantCode"></c-input>
					</c-form-item>
					<div class="m-merchant-check">
						<span v-if="checkedMerchant" class="z-ok">{{checkedMerchant.merchant_name}}</span>
						<span v-if="checkError" class="z-err">{{checkError}}</span>
					</div>
					<c-form-item label="分润比例" required>
						<c-input v-model="shareRatio" name="share_ratio" type="number" decimal="2" :range="[0, 100]" append-text="%" placeholder="双方协商好的分润比例"></c-input>
					</c-form-item>
					<div class="m-ratio-tip">接收方销售后你方获得的利润比例；创建调拨单时默认采用且不可修改。</div>
				</c-form>
			</c-dialog>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_profit_merchant',

		data() {
			return {
				enabledOptions: [
					{name: '启用', value: 1},
					{name: '禁用', value: 2}
				],
				editState: false,
				editId: null,
				merchantCode: '',
				shareRatio: '',
				checkedMerchant: null,
				checkError: ''
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			/********搜索************/
			searchHandle(data) {
				if (!data) {
					data = {};
				}
				this.$refs.list.load({
					url: '/profitTransferMerchant/list',
					data
				});
			},

			/********分润比例展示（去尾零加百分号）************/
			formatRatio(val) {
				if (val === null || val === undefined || val === '') {
					return '-';
				}
				return Number(val) + '%';
			},

			/********打开添加弹窗************/
			openAdd() {
				this.editState = false;
				this.editId = null;
				this.merchantCode = '';
				this.shareRatio = '';
				this.checkedMerchant = null;
				this.checkError = '';
				this.$refs.form.clear();
				this.$refs.dialog.open({title: '添加分润调拨商户'});
			},

			/********打开编辑弹窗（仅分润比例可改）************/
			openEdit(data) {
				this.editState = true;
				this.editId = data.id;
				this.merchantCode = data.merchant_code;
				this.shareRatio = data.share_ratio;
				this.checkedMerchant = {merchant_name: data.merchant_name};
				this.checkError = '';
				this.$refs.dialog.open({title: '编辑分润调拨商户'});
			},
			
			/********商户代码输入时清空校验结果************/
			onCodeInput() {
				//编辑态代码框禁用，input 事件仅来自回填，不清空商户名称提示
				if (this.editState) {
					return;
				}
				this.checkedMerchant = null;
				this.checkError = '';
			},

			/********商户简码失焦反查商户名称************/
			checkMerchantCode() {
				if (this.editState) {
					return;
				}
				const code = (this.merchantCode || '').trim();
				this.checkedMerchant = null;
				this.checkError = '';
				if (!code) {
					return;
				}
				this.request({
					url: '/profitTransferMerchant/checkCode',
					data: {merchant_code: code},
					success: data => {
						this.checkedMerchant = data;
						this.checkError = '';
					},
					fail: (code, data, msg) => {
						this.checkedMerchant = null;
						this.checkError = msg || '商户简码不存在';
						return false;
					}
				});
			},

			/********提交添加/编辑************/
			submitMerchant(stop, next) {
				stop();
				const code = (this.merchantCode || '').trim();
				if (!this.editState && !code) {
					this.$message({message: '请输入商户简码', type: 'warning'});
					return;
				}
				if (!this.editState && !this.checkedMerchant) {
					this.$message({message: '商户简码校验未通过，请重新输入', type: 'warning'});
					return;
				}
				const ratio = (this.shareRatio === null || this.shareRatio === undefined) ? '' : String(this.shareRatio).trim();
				if (!ratio) {
					this.$message({message: '请输入分润比例', type: 'warning'});
					return;
				}
				const ratioNum = Number(ratio);
				if (isNaN(ratioNum) || ratioNum <= 0 || ratioNum > 100) {
					this.$message({message: '分润比例须大于0且不超过100', type: 'warning'});
					return;
				}
				const payload = this.editState
					? {id: this.editId, share_ratio: ratio}
					: {merchant_code: code, share_ratio: ratio};
				this.request({
					url: this.editState ? '/profitTransferMerchant/update' : '/profitTransferMerchant/add',
					data: payload,
					loading: true,
					success: (res, msg) => {
						next();
						this.$message({message: msg || '提交成功', type: 'success'});
						this.$refs.list.update();
					},
					fail: (code, data, msg) => {
						this.$message({message: msg, type: 'error'});
						return false;
					}
				});
			},

			/********启用/禁用调拨对象************/
			toggleHandle(state, next, data) {
				this.request({
					url: '/profitTransferMerchant/toggle',
					data: {
						id: data.id,
						is_enabled: state ? 2 : 1
					},
					success: (res, msg) => {
						this.$message({message: msg || '设置成功', type: 'success'});
						next();
					}
				});
			},

			/********删除调拨对象************/
			removeMerchant(data) {
				this.$confirm({
					message: '确认删除调拨对象【' + data.merchant_name + '】？删除后不影响历史单据',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransferMerchant/delete',
							data: {id: data.id},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '删除成功', type: 'success'});
								this.$refs.list.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-merchant-check {
		min-height: 20px;
		margin: 2px 0 0px;
		font-size: 12px;
		line-height: 20px;

		.z-ok {
			color: #409EFF;
		}

		.z-err {
			color: #F56C6C;
		}
	}

	.m-ratio-tip {
		margin: 2px 0 8px;
		font-size: 12px;
		line-height: 18px;
		color: #999;
	}
</style>
